export function OfferSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
      <div className="absolute inset-0 opacity-5">
        <img
          alt=""
          className="w-full h-full object-cover object-center mix-blend-screen"
          src="https://public.readdy.ai/ai/img_res/0f97b7b948d087c5be562f84f625881a.jpg"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/30"></div>
      <div className="absolute top-20 right-10 opacity-10">
        <img
          alt=""
          className="w-64 h-64 object-contain animate-pulse"
          src="https://public.readdy.ai/ai/img_res/17bf305b67cdd95d513f423310e4aa56.jpg"
        />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-24 sm:py-32 w-full">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="space-y-6 sm:space-y-8">
            <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20">
              <span className="text-xl sm:text-2xl">🔥</span>
              <span className="text-white text-xs sm:text-sm font-medium">
                Oferta de Lanzamiento - Solo por Tiempo Limitado
              </span>
            </div>

            <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-extrabold text-white leading-tight">
              ¡CONVIÉRTETE EN UN EXPERTO EN{' '}
              <span className="bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">
                TRÁFICO Y VENTAS DIGITALES!
              </span>
            </h1>

            <p className="text-base sm:text-lg lg:text-xl text-white/80 leading-relaxed">
              Aprende estrategias comprobadas para vender productos online TODOS LOS DÍAS con publicidad pagada, incluso si estás empezando desde cero.
            </p>

            <div className="space-y-3 sm:space-y-4">
              <div className="flex items-start gap-2 sm:gap-3">
                <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-gradient-to-r from-emerald-500 to-cyan-500 flex items-center justify-center mt-1">
                  <i className="ri-check-line text-white"></i>
                </div>
                <span className="text-white text-sm sm:text-base lg:text-lg">
                  Vender productos digitales utilizando la inteligencia artificial
                </span>
              </div>
              <div className="flex items-start gap-2 sm:gap-3">
                <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-gradient-to-r from-emerald-500 to-cyan-500 flex items-center justify-center mt-1">
                  <i className="ri-check-line text-white"></i>
                </div>
                <span className="text-white text-sm sm:text-base lg:text-lg">
                  El paso a paso desde cero para poder generar ingresos todos los meses y en tiempo récord
                </span>
              </div>
              <div className="flex items-start gap-2 sm:gap-3">
                <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-gradient-to-r from-emerald-500 to-cyan-500 flex items-center justify-center mt-1">
                  <i className="ri-check-line text-white"></i>
                </div>
                <span className="text-white text-sm sm:text-base lg:text-lg">
                  Escalar tus resultados mes a mes con una metodología comprobada por nuestros alumnos
                </span>
              </div>
            </div>

            <div className="space-y-3">
              <a
                href="https://pay.hotmart.com/I103812749W?off=gkmu5rxa&checkoutMode=10"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-emerald-600 font-semibold hover:gap-4 transition-all cursor-pointer"
              >
                QUIERO ACCEDER AHORA →
              </a>
              <p className="text-white/60 text-xs sm:text-sm">
                Acceso por S/70 de por vida • Acceso inmediato
              </p>
            </div>

            <div className="flex flex-wrap gap-6 sm:gap-8 pt-4">
              <div className="text-center">
                <div className="text-2xl sm:text-3xl font-bold text-white">500+</div>
                <div className="text-white/60 text-xs sm:text-sm whitespace-nowrap">Estudiantes</div>
              </div>
              <div className="text-center">
                <div className="text-2xl sm:text-3xl font-bold text-white flex items-center gap-1 justify-center">
                  4.9 <i className="ri-star-fill text-yellow-400 text-xl sm:text-2xl"></i>
                </div>
                <div className="text-white/60 text-xs sm:text-sm whitespace-nowrap">Rating</div>
              </div>
              <div className="text-center">
                <div className="text-2xl sm:text-3xl font-bold text-white whitespace-nowrap">30 días</div>
                <div className="text-white/60 text-xs sm:text-sm whitespace-nowrap">Garantía</div>
              </div>
            </div>
          </div>

          <div className="relative hidden lg:block">
            <div className="relative">
              <div className="relative rounded-3xl overflow-hidden shadow-2xl transform rotate-3 hover:rotate-0 transition-transform duration-500">
                <img
                  alt="Dashboard"
                  className="w-full h-auto object-cover"
                  src="https://static.readdy.ai/image/35f0715deb3f0b80002922a6d1f4e543/ed8f4c70da48f615e6a248f14a7f4fba.png"
                />
              </div>
              <div className="absolute -top-6 -right-6 w-32 h-32 bg-gradient-to-br from-emerald-400 to-cyan-400 rounded-full blur-3xl opacity-60 animate-pulse"></div>
              <div className="absolute -bottom-6 -left-6 w-40 h-40 bg-gradient-to-br from-purple-400 to-pink-400 rounded-full blur-3xl opacity-40 animate-pulse"></div>
              <div className="absolute top-8 -left-4 bg-yellow-400 text-gray-900 px-4 py-2 rounded-lg font-bold shadow-xl transform -rotate-6 whitespace-nowrap">
                ✨ Resultados Reales
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
